import { render, staticRenderFns } from "./PlayerNoticeWrite.vue?vue&type=template&id=32fed40a&"
import script from "./PlayerNoticeWrite.vue?vue&type=script&lang=js&"
export * from "./PlayerNoticeWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports